import { render, staticRenderFns } from "./editExamineeBaseInfo.vue?vue&type=template&id=63ed98f6&scoped=true&"
import script from "./editExamineeBaseInfo.vue?vue&type=script&lang=js&"
export * from "./editExamineeBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./editExamineeBaseInfo.vue?vue&type=style&index=0&id=63ed98f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed98f6",
  null
  
)

export default component.exports